import React from 'react';
import Title from './Title';
import Btn from './Btn';
import labormove from '../img/labormove.png';
import dots from '../img/dots_img.png';
import Checklist from './Checklist';

export default function RemovalServices() {
  return (
    <>
      <div className='removal_services pt-0 pt-lg-5 pb-0 pb-lg-5'>
        <div className='container'>
          <div className="serviceSec pt-3 pt-sm-5 pb-3 pb-sm-5 " >
                    <div className="row align-items-center flex-lg-row-reverse" >
                        <div className="col-lg-6" >
                            <Title mainClass="mb-3"
                                subheading="Service: labor"
                                subclass=" border-none text-start text-uppercase"
                                titleclass="lg heading text-dark text-start mb-2 mt-0 mt-lg-2"
                                desclass="mb-0"
                                title={<>Hourly Labor & Moving <br/>
                                    Services</>}
                                des="Sit Back and Let The Exquisite Moves do the Work. Friendly & Affordable Home & Business Service Solutions"/>


<Checklist 
                                list={["Hourly Labor Services", "Truck Loading & Unloading Services ", "Professional Packing Services"]}
                                class="mt-3 mt-lg-4 mb-0 mb-lg-3 text-dark" 
                                col="col-12" 
                                liststyle="rounded"  /> 
                            <Btn class="mt-1"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            >Book now Junk Removal Service</Btn>
                        </div>
                        <div className="col-lg-6 pt-4 pt-lg-0 pe-lg-5 position-relative " >
                            <img src={dots} alt='dots' className='dots_img' />
                            <img src={labormove} className="img-fluid" alt="services" />
                        </div>
                    </div>
                </div>
        </div>
      </div>
    </>
  )
}
